import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    center: {
      textAlign: 'center',
    },
    centerFields: {
      textAlign: 'center',
      fontSize: 12,

      '& .MuiIconButton-root': {
        padding: 0,
      },
    },
    accessButton: {
      fontSize: 15,
      color: palette.blue,
    },

    companyName: {
      fontSize: 12,
      whiteSpace: 'nowrap',
    },
    searchContainer: { alignItems: 'center', justifyContent: 'space-between' },
    editIcon: {
      width: 16,
      height: 16,
      color: palette.gray,
    },
  });
